import { Button, Grid, TextField } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { useController } from '../assets/components/BaseContrroler'

function Contact() {

    const { baseController: { homeController } } = useController()
    const { setNavbar, setUrl } = homeController

    useEffect(() => {
        setUrl('/contact')
        setNavbar(true)
    })


    var logo = require('../assets/images/logo1.png')

    return (
        <div>
            <div className='banner-inner position relative' style={{
                // backgroundImage: "url(https://www.awlindia.com/img/contact-us-banner.jpg)",
                // backgroundImage: "url(https://www.guynixon.co.uk/wp-content/uploads/2015/04/contact-us.jpg)",

                // backgroundImage: logo,
            }} >
                <div className="position-absolute top-0 left-0 start-0">
                    <img src={require('../assets/images/contact-us-banner2.jpg')} className='contact-banner-img' />
                </div>

                <div className="banner-overlay">
                    <div className="conatiner">
                        <div className="banner-caption">

                            <h4 className="banner-title">Contact </h4>
                            <p className="banner-sub-text">Please fill in the form We will get in touch with you as earliest.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: 10, backgroundColor: 'white' }}>

            </div>
            <div className="container-fluid w-85">

                <div className="row contact-body">
                    <div className="col-lg-6 col-md-12 col-sm-12 my-5">
                        <h2>KEEP IN TOUCH</h2>

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField id="outlined-basic" label="Full Name" variant="outlined" fullWidth />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField id="outlined-basic" label="Your Email" variant="outlined" fullWidth />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField id="outlined-basic" label="Mobile No" variant="outlined" fullWidth />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField id="outlined-basic" label="Services" variant="outlined" fullWidth />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField id="outlined-basic" label="Message" variant="outlined" fullWidth rows={4} multiline />
                            </Grid>

                            <Grid item xs={4}>
                                <Button variant="contained">Send Request</Button>
                            </Grid>
                        </Grid>


                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="our-office">
                            <h3 className='fw-bold'>OUR OFFICE</h3>
                            <h4>Feel free to contact us.</h4>
                            <p className='text-justify'>Thank you for visiting our website. If you have any questions, feedback, or inquiries, please don't hesitate to reach out to us. Our team is here to assist you and will get back to you as soon as possible.
                            </p>

                            <p className="awl-india">M/S KARNAFULLY INTERNATIONAL</p>
                            <p className="address">110, Abdul Latif Market (2nd Floor)
                                3 No Jetty Gate, Fakirhat Road, Bandar,
                                Chattogram-4100.</p>

                            <p className="phone">Phone: 023333 17292</p>

                            <p className="sales" ><a href="#"> info@karnafullygroup.com</a></p>

                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <h4 className="text-center bg-dark text-light py-1">Location</h4>
                <div className="google-map-code">
                    <iframe
                        title="google map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.009760966918!2d91.8053517!3d22.315470599999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30acdf3105e4670b%3A0xaaaf0590ffbc05b3!2sM%2FS.%20Karnafully%20International!5e0!3m2!1sen!2sbd!4v1738822279208!5m2!1sen!2sbd"
                        width="100%"
                        height="500"
                        style={{ border: 0 }}
                        loading="lazy"
                    ></iframe>
                </div>
            </div>
        </div >
    )
}

export default observer(Contact)